module.exports = __webpack_public_path__ + "img/mortage.100f2e6f.jpeg";